import { metricsBus } from "@/common/buses";
import gaMetrics from "@/common/services/ga/gaMetrics";

metricsBus.on("gifView", () => gaMetrics.sendGifView());

metricsBus.on("meaningfulGifView", () => gaMetrics.sendMeaningfulGifView());

metricsBus.on("gifReplay", () => gaMetrics.sendGifReplay());

metricsBus.on("uploadSelected", async ({ type }) => {
  switch (type) {
    case "video":
      await gaMetrics.sendUploadVideoSelected();
      break;
    case "image":
      await gaMetrics.sendUploadImageSelected();
      break;
    case "bulkImages":
      await gaMetrics.sendUploadBulkClick();
      break;
    case "url":
      await gaMetrics.sendUploadUrlSelected();
      break;
    default:
      console.error(`[GA] Undefined upload type: ${type}`);
  }
});

metricsBus.on("uploadStarted", () => gaMetrics.sendUploadStarted());

metricsBus.on("uploadTagSelectionEnded", () => gaMetrics.sendUploadTagsSelected());

metricsBus.on("uploadEnded", () => gaMetrics.sendUploadPublished());

metricsBus.on("gifClicked", () => gaMetrics.sendGifClick());

metricsBus.on("gifLiked", () => gaMetrics.sendLiked());

metricsBus.on("addedToCollection", () => gaMetrics.sendAddedToCollection());

metricsBus.on("fullscreenEntered", () => gaMetrics.sendEnterFullscreen());

metricsBus.on("adLoaded", async({ isLoaded }) => {
  if (isLoaded) {
    await gaMetrics.sendAdLoaded();
  }
});

metricsBus.on("infoBarClicked", () => gaMetrics.sendInfobarCta());

metricsBus.on("infoBarClosed", () => gaMetrics.sendInfobarDismiss());

metricsBus.on("sharedFixedEmbed", () => gaMetrics.sendShareEmbedFixed());

metricsBus.on("sharedResponsiveEmbed", () => gaMetrics.sendShareEmbedResponsive());

metricsBus.on("shareClick", () => gaMetrics.sendShareClick());

metricsBus.on("shareCopy", () => gaMetrics.sendShareCopy());

metricsBus.on("shareEmbed", () => gaMetrics.sendShareEmbed());

metricsBus.on("shareTwitter", () => gaMetrics.sendShareTwitter());

metricsBus.on("shareReddit", () => gaMetrics.sendShareReddit());

metricsBus.on("shareDiscord", () => gaMetrics.sendShareDiscord());

metricsBus.on("optionClicked", () => gaMetrics.sendOptionClick());

metricsBus.on("pinnedContentClicked", () => gaMetrics.sendPinnedContentClick());

metricsBus.on("PWASessionStarted", () => gaMetrics.sendPWASessionStarted());

metricsBus.on("menuButtonClicked", () => gaMetrics.sendMenuButtonClicked());

metricsBus.on("followUserClicked", () => gaMetrics.sendFollowUserClicked());

metricsBus.on("socialProfileClicked", () => gaMetrics.sendSocialProfileClick());

metricsBus.on("tagClicked", () => gaMetrics.sendTagClicked());

metricsBus.on("signUpSuccess", () => gaMetrics.sendSignUpSuccessful());

metricsBus.on("searched", () => gaMetrics.sendSearch());

metricsBus.on("uploadVideoTrimmed", () => gaMetrics.sendUploadVideoTrim());

metricsBus.on("uploadSourceConfirmed", async ({ type }) => {
  switch (type) {
    case "video":
      await gaMetrics.sendUploadVideoConfirmed();
      break;
    case "image":
      await gaMetrics.sendUploadImageConfirmed();
      break;
    case "multiple":
      await gaMetrics.sendUploadMultipleConfirmed();
      break;
    default:
      console.error(`[GA] Undefined upload type: ${type}`);
  }
});

metricsBus.on("uploadAudienceDefined", () => gaMetrics.sendUploadAudienceDefined());

metricsBus.on("uploadSourceDropped", async ({ type }) => {
  switch (type) {
    case "video":
      await gaMetrics.sendUploadVideoDropped();
      break;
    case "image":
      await gaMetrics.sendUploadImageDropped();
      break;
    case "images":
      await gaMetrics.sendUploadImagesDropped();
      break;
    default:
      console.error(`[GA] Undefined upload type: ${type}`);
  }
});

metricsBus.on("uploadFinished", () => gaMetrics.sendUploadFinisher());

metricsBus.on("gifWatched120s", () => gaMetrics.sendWatch120s());

metricsBus.on("profileViewed", () => gaMetrics.sendProfileView());

metricsBus.on("voteUpAddClicked", () => gaMetrics.sendVoteUpAddClick());

metricsBus.on("voteUpRemoveClicked", () => gaMetrics.sendVoteUpRemoveClick());

metricsBus.on("voteDownAddClicked", () => gaMetrics.sendVoteDownAddClick());

metricsBus.on("voteDownRemoveClicked", () => gaMetrics.sendVoteDownRemoveClick());

metricsBus.on("privateSessionStarted", () => gaMetrics.sendSessionStartPrivate());

metricsBus.on("tagFeedbackEnabledOptions", () => gaMetrics.sendTagFeedbackEnabledOptions());

metricsBus.on("playerNicheClicked", () => gaMetrics.sendPlayerNicheClick());

metricsBus.on("playerTagClicked", () => gaMetrics.sendPlayerTagClick());

metricsBus.on("verificationSubmit", () => gaMetrics.sendVerificationSubmit());

metricsBus.on("orientationChanged", async ({ type }) => {
  if (type.includes("landscape")) {
    await gaMetrics.sendHorizontalOrientation();
  }

  if (type.includes("portrait")) {
    await gaMetrics.sendVerticalOrientation();
  }
});

metricsBus.on("nicheGifsOrderChanged", () => gaMetrics.sendNicheGifsOrderChanged());

metricsBus.on("nicheCategoryClicked", () => gaMetrics.sendNicheCategoryClicked());

metricsBus.on("ageGateRedirected", (props) => gaMetrics.sendAgeGateRedirected(props));

metricsBus.on("ageVerificationPromptShown", (props) => gaMetrics.sendAgeVerificationPromptShown(props));

metricsBus.on("ageVerificationStarted", (props) => gaMetrics.sendAgeVerificationStarted(props));

metricsBus.on("ageVerificationCompleted", (props) => gaMetrics.sendAgeVerificationCompleted(props));

metricsBus.on("ageVerificationFailed", (props) => gaMetrics.sendAgeVerificationFailed(props));

metricsBus.on("ageVerificationAbandoned", (props) => gaMetrics.sendAgeVerificationAbandoned(props));

metricsBus.on("enterRedgifsClicked", (props) => gaMetrics.sendEnterRedgifsClicked(props));

metricsBus.on("ageVerificationLiteStayed", (props) => gaMetrics.sendAgeVerificationLiteStayed(props));

metricsBus.on("registrationBannerImpression", () => {
  return gaMetrics.sendRegistrationBannerImpression();
});

metricsBus.on("registrationBannerClick", () => {
  return gaMetrics.sendRegistrationBannerClick();
});

metricsBus.on("registrationBannerClosed", () => {
  return gaMetrics.sendRegistrationBannerClosed();
});

metricsBus.on("registrationStarted", () => {
  return gaMetrics.sendRegistrationStarted();
});

metricsBus.on("registrationSubmitted", () => {
  return gaMetrics.sendRegistrationSubmitted();
});

metricsBus.on("registrationVerificationCodeSent", () => {
  return gaMetrics.sendRegistrationVerificationCodeSent();
});

